<template>
  <div class="stat">
    <div class="stat-container">
      <div class="top-banner">
        <van-nav-bar 
          left-text="返回" 
          :title="statTitle"
          left-arrow 
          @click-left="onClickLeft"
        >
        </van-nav-bar>
      </div>
      <div class="content">
        <div class="stat-card">
          <div class="card-title">直播数据</div>
          <div class="card-content">
            <div class="stat-item">
              <div class="i-title">观看人数</div>
              <div class="i-value">{{ stat && stat.total_play_count ? stat.total_play_count : '-' }}</div>
            </div>
            <div class="stat-item">
              <div class="i-title">完播次数</div>
              <div class="i-value">{{ stat && stat.total_play_finish ? stat.total_play_finish : '-' }}</div>
            </div>
            <div class="stat-item">
              <div class="i-title">完播率</div>
              <div class="i-value">{{ stat && stat.total_play_count > 0 ? ((stat.total_play_finish / stat.total_play_count * 100).toFixed(2)) + '%' : '-' }}</div>
            </div>
          </div>
        </div>
        <div class="stat-card">
          <div class="card-title">答题数据</div>
          <div class="card-content">
            <div class="stat-item">
              <div class="i-title">答题人数</div>
              <div class="i-value">{{ stat && stat.total_answer_question ? stat.total_answer_question : '-' }}</div>
            </div>
            <div class="stat-item">
              <div class="i-title">答题正确人数</div>
              <div class="i-value">{{ stat && stat.correct_answer_question ? stat.correct_answer_question : '-' }}</div>
            </div>
            <div class="stat-item">
              <div class="i-title">答题正确率</div>
              <div class="i-value">{{ stat && stat.total_answer_question > 0 ? ((stat.correct_answer_question / stat.total_answer_question *
              100).toFixed(2)) + '%' : '-' }}</div>
            </div>
          </div>
        </div>
        <div class="stat-card">
          <div class="card-title">红包数据</div>
          <div class="card-content">
            <div class="stat-item">
              <div class="i-title">红包领取次数</div>
              <div class="i-value">{{ stat && stat.total_rp_count ? stat.total_rp_count : '-' }}</div>
            </div>
            <div class="stat-item">
              <div class="i-title">红包领取金额</div>
              <div class="i-value">{{ stat && stat.total_rp_money ? (stat.total_rp_money / 100).toFixed(1) : '-' }}</div>
            </div>
          </div>
        </div>

        <div class="view-function">
          <van-button block round color="#7684e7" @click="showCustomer" v-if="user.member_type == 2">查看参与记录</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { eventInfo, eventStat } from '@/api/event'

export default {
  name: 'SupportStat',
  data() {
    return {
      stat: {
        "total_play_count": 0,
        "total_play_finish": 0,
        "total_answer_question": 0,
        "correct_answer_question": 0,
        "total_rp_count": 0,
        "total_rp_money": 0,
      },
      evt_id: 0,
      event: {
        name: ''
      }
    }
  },
  computed: {
    ...mapState(['user']),
    statTitle() {
      return this.event.name;
    },
    res_url() {
      return window.__config__.res_url;
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.evt_id = this.$route.params.id;
      this.loadData(this.evt_id)
    },
    onClickLeft() {
      this.$router.back();
    },
    loadData(evt_id) {
      eventInfo(evt_id).then(resp => {
        this.event = resp.data
      })
      eventStat(evt_id).then(resp => {
        this.stat = resp.data
      })
    },
    showCustomer() {
      this.$router.push('/GMEventCustomer/' + this.evt_id)
    }
  }
}
</script>
<style lang="scss" scoped>
.stat-container {
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  
  .view-function {
    margin: 20px;
  }
  .stat-card {
    margin: 12px 16px;
    overflow: hidden;
    border-radius: 8px;
    background-color: #fff;
    padding: 0 12px;
    
    .card-title {
      padding: 10px 0;
      font-size: 16px;
      font-weight: 400;
      border-bottom: 1px solid #ccc;
    }
    .card-content {
      display: flex;
      padding: 10px 0;
      .stat-item {
        flex: 0 0 33.33%;
        .i-title {
          font-size: 14px;
          color: #999;
          margin-bottom: 4px;
        }
        .i-value {
          font-size: 22px;
          color: #333;
        }
      }
    }
  }
  
}
</style>
